import { ICountry } from '@boma/website/shared/entities';

export interface IDeposits {
  deposits: IDeposit[];
}

export interface IDeposit {
  amount: number;
  user: {
    id: string;
    firstName: string;
    surname: string;
    contactNumber: string;
  }; // todo create better IUser interfaces
  country: ICountry; // TODO THIS IS REDUNDANT NOW?
  entityLocation: string;
  type: string; //TODO DepositType enum could be used here
  nameOfLocation: string;
  reference: string;
  comment: string;
  createdAt: string;
  updatedAt: string;
}
